import { useEffect, useState, createContext } from "react";

const CompactModeWidthBreakpoint = 900;

interface WindowSize {
	width: number;
	height: number;
}

const calculateWindowSize: () => WindowSize = () => {
	return {
		width: window.innerWidth,
		height: window.innerHeight
	};
}

export enum SiteResolution {
	Desktop = "DESKTOP",
	Compact = "Compact"
}

export function decodeSiteResolutionFunc<T>(siteResolution: SiteResolution, onDesktop: () => T, onCompact: () => T): T {
	switch (siteResolution) {
		case SiteResolution.Desktop:
			return onDesktop();
		case SiteResolution.Compact:
			return onCompact();
		default:
			throw `Unsupported site resolution ${siteResolution}`;
	}
}
export function decodeSiteResolutionValue<T>(siteResolution: SiteResolution, onDesktop: T, onCompact: T): T {
	switch (siteResolution) {
		case SiteResolution.Desktop:
			return onDesktop;
		case SiteResolution.Compact:
			return onCompact;
		default:
			throw `Unsupported site resolution ${siteResolution}`;
	}
}

export const SiteResolutionContext = createContext<SiteResolution>(SiteResolution.Desktop);

const calculateSiteResolution = (size: WindowSize) => {
	return size.width < CompactModeWidthBreakpoint ? SiteResolution.Compact : SiteResolution.Desktop;
}

export const useSiteResolution = () => {
	const [windowSize, setWindowSize] = useState<WindowSize>(calculateWindowSize());

	useEffect(() => {
		if (!window.matchMedia)
			return;

		const mediaQuery: any = window.matchMedia(`(min-width: ${CompactModeWidthBreakpoint}px)`);
		if (!mediaQuery || !mediaQuery.addEventListener)
			return;

		mediaQuery.addEventListener("change", () => {
			setWindowSize(calculateWindowSize());
		});
	}, []);

	const siteResolution = calculateSiteResolution(windowSize);
	return siteResolution;
}

export const calculateSiteResolutionIndependent = () => {
	const windowSize = calculateWindowSize();
	return calculateSiteResolution(windowSize);
}
